var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 86,
    viewBox: "0 0 41 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_64_2035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.775 45.74C5.04833 45.74 3.185 44.2883 3.185 41.385V35.6C3.185 32.61 4.94 31.115 8.45 31.115H21.97C23.7033 31.115 24.57 31.57 24.57 32.48C24.57 33.26 23.7033 33.65 21.97 33.65H11.375C8.94833 33.65 7.735 34.95 7.735 37.55V39.175C7.735 41.905 8.92667 43.27 11.31 43.27H18.98C22.7067 43.27 24.57 44.7217 24.57 47.625V54.645C24.57 57.5483 22.7717 59 19.175 59H5.72C4.03 59 3.185 58.5883 3.185 57.765C3.185 56.985 4.05167 56.595 5.785 56.595H16.51C18.85 56.595 20.02 55.4467 20.02 53.15V50.095C20.02 47.1917 18.785 45.74 16.315 45.74H8.775Z",
    fill: "#1731AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.775 26.74C15.0483 26.74 13.185 25.2883 13.185 22.385V16.6C13.185 13.61 14.94 12.115 18.45 12.115H31.97C33.7033 12.115 34.57 12.57 34.57 13.48C34.57 14.26 33.7033 14.65 31.97 14.65H21.375C18.9483 14.65 17.735 15.95 17.735 18.55V20.175C17.735 22.905 18.9267 24.27 21.31 24.27H28.98C32.7067 24.27 34.57 25.7217 34.57 28.625V35.645C34.57 38.5483 32.7717 40 29.175 40H15.72C14.03 40 13.185 39.5883 13.185 38.765C13.185 37.985 14.0517 37.595 15.785 37.595H26.51C28.85 37.595 30.02 36.4467 30.02 34.15V31.095C30.02 28.1917 28.785 26.74 26.315 26.74H18.775Z",
    fill: "#1731AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_64_2035",
    x: 1.185,
    y: 11.115,
    width: 39.385,
    height: 54.885,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_64_2035"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_64_2035",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmLogo);
export default __webpack_public_path__ + "static/media/sm-logo.78d73171321e0f335e51d172c7f24aa3.svg";
export { ForwardRef as ReactComponent };